
  import { Vue, Component } from "vue-property-decorator";
  import CompanyLogo from "@/components/icons/logo/NewLogo.vue";

  @Component({
    components: {
      CompanyLogo,
    },
  })
  export default class AuthViewContainer extends Vue {}
